import { createVNode as n, mergeProps as o } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/UserManageFilledStandard.js";
import l from "../components/PfIcon.js";
const r = (e, a) => {
  const t = {
    ...e,
    ...a.attrs
  };
  return n(l, o(t, {
    icon: d
  }), null);
};
r.displayName = "UserManageFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
